/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesGoCampaign_PrecinctGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Precinct Group Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, September 29, 2019 - 08:26:08 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/29/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const GoCampaign_PrecinctGroupList = Loadable({
    loader: () => import('../containers/GoCampaign_PrecinctGroups/GoCampaign_PrecinctGroupListContainer'),
    loading: Loading,
});

export const GoCampaign_PrecinctGroupForm = Loadable({
    loader: () => import('../containers/GoCampaign_PrecinctGroups/GoCampaign_PrecinctGroupEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesGoCampaign_PrecinctGroups.js